import moment from 'moment';
import _ from 'lodash';

export default class EventController {

  constructor(OfficesService) {
    'ngInject';
    Object.assign(this, {OfficesService});
    OfficesService.list().then(offices => this.offices = _.keyBy(offices, 'id'));
  }

  officeName(id) {
    return _.has(this.offices, id) ? this.offices[id].label : '';
  }

  ifFullDay(event) {
    return event.start_timestamp.format('HH:mm:ss') == '00:00:00';
  }

  eventTime(event) {
    return `${event.start_timestamp.format('HH:mm')} ${moment(event.a, 'DD/MM/YYYY HH:mm').format('HH:mm')}`;
  }
}


// WEBPACK FOOTER //
// ./client/app/components/events/event/event.controller.js